import { Injectable } from '@angular/core';
import { SessionService } from '../session.service';
import { HttpClient } from '@angular/common/http';
import { URLService } from '../url.service';
import { ISession } from '../session.interface';
import { ICreatePinVerificationResponse } from './create-pin-verification-response.interface';
import { mergeMap, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IConfirmPinVerificationRequest } from './confirm-pin-verification-request.interface';
import { IConfirmPinVerificationResponse } from './confirm-pin-verification-response.interface';

@Injectable({
  providedIn: 'root',
})
export class PinVerificationService {
  constructor(
    private sessionService: SessionService,
    private http: HttpClient,
    private urlService: URLService,
  ) {}

  public createPinVerification(
    email: string,
  ): Observable<ICreatePinVerificationResponse | undefined> {
    const session = this.sessionService.getCurrentSession();

    let session$ = of(session);
    if (!session) {
      session$ = this.sessionService.getSession();
    }

    return session$.pipe(
      mergeMap((session) => this.createPinVerificationRequest(email, session)),
    );
  }

  public confirmPinVerification(
    email: string,
    id: string,
    pin: string,
  ): Observable<IConfirmPinVerificationResponse | undefined> {
    const session = this.sessionService.getCurrentSession();

    let session$ = of(session);
    if (!session) {
      session$ = this.sessionService.getSession();
    }

    return session$.pipe(
      mergeMap((session) =>
        this.confirmPinVerificationRequest(email, id, { pin }, session),
      ),
    );
  }

  private createPinVerificationRequest(
    email: string,
    session?: ISession,
  ): Observable<ICreatePinVerificationResponse | undefined> {
    return this.http
      .post<ICreatePinVerificationResponse>(
        this.urlService.createPinVerification(email),
        null,
        {
          headers: {
            authorization: session?.authorizationString || '',
            'X-Region': session?.region || 'USA',
          },
        },
      )
      .pipe(
        catchError((err) => {
          return of(err?.error);
        }),
      );
  }

  private confirmPinVerificationRequest(
    email: string,
    id: string,
    payload: IConfirmPinVerificationRequest,
    session?: ISession,
  ): Observable<IConfirmPinVerificationResponse | undefined> {
    return this.http
      .post<IConfirmPinVerificationResponse>(
        this.urlService.confirmPinVerification(email, id),
        payload,
        {
          headers: {
            authorization: session?.authorizationString || '',
            'X-Region': session?.region || 'USA',
          },
        },
      )
      .pipe(
        catchError((err) => {
          return of(err?.error);
        }),
      );
  }
}
